<template>
  <div class="sale-try-again text-center">
    <button class="btn-close" @click="$emit('close')">
      <i class="icon-x"></i>
    </button>
    <div v-if="status === 'initial'">
      <h4 class="mb-6">
        Tem certeza que deseja tentar realizar a cobrança novamente?
      </h4>
      <button class="btn btn-primary px-9" @click="retry" :disabled="loading">
        <loading :show="loading">Confirmar</loading>
      </button>
    </div>

    <div v-else-if="status === 'change-card'">
      <h4 class="mb-5">
        Não foi possível processar o pagamento.
      </h4>
      <p class="mb-6">
        Para nova tentativa, solicite que o cliente recadastre e autorize
      </p>
      <button
        class="btn btn-primary px-9"
        @click="changeCard"
        :disabled="loading"
      >
        <loading :show="loading">Solicitar Agora</loading>
      </button>
    </div>

    <div v-else-if="status === 'change-card-success'">
      <p>
        Foi enviado um e-mail para {{ item.shopper_email }} avisando o cliente
        para recadastrar os dados de pagamento.
      </p>
      <p>
        Caso queria encaminhar por outro canal este é o link 🔗 específico do
        cliente:
      </p>

      <div class="input-group mb-6">
        <input
          type="text"
          readonly
          class="form-control m-0"
          :value="changeCardLink"
        />
        <div class="input-group-append">
          <button
            @click="copyLink"
            class="btn btn-primary btn-sm"
            type="button"
          >
            Copiar
          </button>
        </div>
      </div>

      <button class="btn btn-primary px-9" @click="$emit('close')">
        Fechar
      </button>
    </div>
  </div>
</template>

<script>
import get from "lodash/get";

export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      status: "initial",
      loading: false,
      changeCardLink: ""
    };
  },
  methods: {
    retry() {
      this.loading = true;
      window.axios
        .get(`/subscriptions/reprocess-order/${this.item.id}`)
        .then(response => {
          const msg = get(
            response,
            "data.message",
            "Cobrança realizada com sucesso"
          );
          this.$message.success(msg);
          this.$emit("close");
          this.$emit("refresh");
        })
        .catch(error => {
          const msg = get(
            error,
            "response.data.message",
            "Erro ao realizar cobrança"
          );
          this.$message.error(msg);
          if (get(error, "response.data.change_card")) {
            this.status = "change-card";
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changeCard() {
      this.loading = true;
      this.$store
        .dispatch("subscriptions/requestChangeCard", this.item.id)
        .then(response => {
          this.$message.success(
            "Um e-mail foi enviado ao cliente com um link para alterar os dados do cartão"
          );
          this.status = "change-card-success";
          this.changeCardLink = response.data.link;
        })
        .catch(() => {
          this.$message.error("Erro");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    copyLink() {
      let link = this.changeCardLink;
      if (link) {
        navigator.clipboard.writeText(link);
        this.$message.success("Link copiado");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.sale-try-again {
  position: relative;

  .btn-close {
    font-size: 20px;
    position: absolute;
    top: 0;
    right: 0;
    padding: 0;
    background: transparent;
    border: none;
  }

  .btn-copy {
    border: none;
    background: transparent;
    padding: 0;
    font-weight: bold;
  }
}
</style>
